import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.a href="https://innershiftstore.com/cart/52044388303130:1" target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`relative group overflow-hidden rounded-md bg-gradient-to-r from-brand-gold to-brand-lightGold text-brand-dark font-bold text-lg md:text-xl px-8 py-4 shadow-[0_0_20px_rgba(212,168,83,0.3)] hover:shadow-[0_0_30px_rgba(212,168,83,0.5)] transition-all duration-300 inline-block cursor-pointer no-underline ${className}`} data-id="element-196">
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-197" />
      <span className="relative z-10 tracking-wide" data-id="element-198">{children}</span>
    </motion.a>;
}